import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const LEAVING_CLASS = 'is-page-leaving';
const ENTERING_CLASS = 'is-page-entering';
// Slightly longer than the enter animation in the theme.
const ENTER_MS = 400;

// This state lives outside the component because Volto remounts the app
// extras when the set of matching extras changes, for example when the
// visitor leaves the home page. The first page comes from the server and
// does not animate, so the shown path starts as the page the bundle loads on.
let shownPathname =
  typeof window === 'undefined' ? null : window.location.pathname;
let loadInFlight = false;
let enterTimer: number | undefined;

// Marks the document around a page change so the theme can animate the
// page content. The class "is-page-leaving" is set while the next page
// loads, "is-page-entering" right after it is shown.
const PageTransition = () => {
  const { pathname } = useLocation();
  const loading = useSelector((state: any) =>
    Boolean(state.content?.get?.loading),
  );

  useEffect(() => {
    const root = document.documentElement;
    if (loading) {
      root.classList.add(LEAVING_CLASS);
      root.classList.remove(ENTERING_CLASS);
      loadInFlight = true;
      return;
    }
    root.classList.remove(LEAVING_CLASS);
    // Only a load that ends on another page is a page change. The page
    // also reloads its content once after the first render.
    const pageChanged = loadInFlight && shownPathname !== pathname;
    loadInFlight = false;
    if (!pageChanged) return;
    shownPathname = pathname;
    root.classList.add(ENTERING_CLASS);
    window.clearTimeout(enterTimer);
    enterTimer = window.setTimeout(
      () => root.classList.remove(ENTERING_CLASS),
      ENTER_MS,
    );
  }, [loading, pathname]);

  return null;
};

export default PageTransition;
